module.exports = __webpack_public_path__ + "static/img/profile.473f597.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/profile.jpg
// module id = ohyW
// module chunks = 166